import React from 'react';

import useInjectScript from './useInjectScript';

const GSI = 'https://accounts.google.com/gsi/client';

const GoogleContext = React.createContext();

const GoogleProvider = ({ children, clientId, apiKey }) => {
  const [loaded, gsiError] = useInjectScript(GSI);
  const [ready, setReady] = React.useState(false);

  const contextValue = React.useMemo(
    () => ({
      loaded: loaded && !gsiError,
      clientId: clientId,
      apiKey,
      ready,
      setReady,
    }),
    [loaded, gsiError, clientId, apiKey, ready]
  );

  return (
    <GoogleContext.Provider value={contextValue}>
      {children}
    </GoogleContext.Provider>
  );
};

export const useGoogleApi = () => React.useContext(GoogleContext);

export default GoogleProvider;
